<template>
    <label :for="name" @click="handleTap">
        <template v-if="special">
            <div class="special-container" :class="[lClass]">
                <slot />
            </div>
        </template>
        <template v-else>
            <div
                :class="['l-btn', 'l-btn-' + size, 'l-btn-' + type,'l-btn-' + shape,plain?'l-btn-plain':'',disabled ? 'l-btn-disabled' : '', lClass]"
                :style="[width?'min-width:'+(width/rootFontSize)+'rem':'',height?'height:'+(height/rootFontSize)+'rem;line-height:'+(height/rootFontSize)+'rem;':'',size=='long'?'border-radius:0':'']"
            >
                <div
                    v-if="loading"
                    :class="['l-btn-loading', 'margin-' + size,plain ?'l-btn-loading-' + type : '']"
                ></div>
                <van-icon
                    v-if="icon"
                    :class="'margin-' + size"
                    class-prefix="l-icon"
                    name="icon"
                    color="iconColor"
                    size="iconSize"
                />
                <slot />
            </div>
        </template>
    </label>
</template>

<script>
import { cssConfig } from '../../config/css'
export default {
    name: 'Button',
    components: {},
    mixins: [],
    props: {
        // button组建标识
        name: {
            type: String,
            default: 'lin'
        },
        type: {
            type: String,
            default: 'default'
        },
        plain: Boolean,
        size: {
            type: String,
            default: 'medium'
        },
        shape: {
            type: String,
            default: 'circle'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        special: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        width: Number,
        height: Number,
        icon: String,
        image: String,
        iconColor: String,
        iconSize: String,
        lClass: {
            type: String,
            default: ''
        },
        lImgClass: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            ...cssConfig
        }
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {
        handleTap() {
            this.$emit('lintap')
        }
    }
}
</script>
<style lang='stylus'>
.btn-hover
    opacity: 0.8
.special-container
    display: flex
.l-btn
    display: inline-flex
    align-items: center
    justify-content: center
    white-space: nowrap
    font-size: 14px
    position: relative
    color: #fff
    padding: 0 6px
    box-sizing: border-box
.l-btn-img-mini
    width: 15px
    height: 15px
.l-btn-img-medium
    width: 18px
    height: 18px
.l-btn-img-large
    height: 22px
    width: 22px
.l-btn-long
    border-radius: 0
    margin: 0
    height: 44px
    width: 375px
.l-btn-medium
    height: 36px
    min-width: 90px
.l-btn-large
    height: 44px
    min-width: 355px
.l-btn-mini
    height: 30px
    min-width: 70px
    font-size: 12px
.l-btn-default
    background-color: #fa671f
.l-btn-success
    background-color: #34bfa3
.l-btn-warning
    background-color: #ffe57f
    color: #333
.l-btn-error
    background-color: #f4516c
.l-btn-square
    border-radius: 0
.l-btn-semicircle
    border-radius: 20px
.l-btn-large.l-btn-semicircle
    border-radius: 24px
.l-btn-mini.l-btn-semicircle
    border-radius: 7.5px
.l-btn-circle
    border-radius: 4px
.l-btn-large.l-btn-circle
    border-radius: 4.8px
.l-btn-mini.l-btn-circle
    border-radius: 3px
.l-btn-plain
    background-color: #fff
    color: #fa671f
    border: 1px solid #fa671f
.l-btn-success.l-btn-plain
    background-color: #fff
    color: #34bfa3
    border: 1px solid #34bfa3
.l-btn-error.l-btn-plain
    background-color: #fff
    color: #f4516c
    border: 1px solid #f4516c
.l-btn-warning.l-btn-plain
    background-color: #fff
    color: #ffe57f
    border: 1px solid #ffe57f
.l-btn-loading
    opacity: 0.6
    display: inline-block
    vertical-align: middle
    width: 12px
    height: 12px
    background: 0 0
    border-radius: 50%
    border: 2px solid #fff
    border-color: #fff #fff #fff transparent
    animation: btn-spin 0.6s linear
    animation-iteration-count: infinite
.l-btn-loading-default
    border: 2px solid #fa671f
    border-color: #fa671f #fa671f #fa671f transparent
.l-btn-loading-success
    border: 2px solid #34bfa3
    border-color: #34bfa3 #34bfa3 #34bfa3 transparent
.l-btn-loading-error
    border: 2px solid #f4516c
    border-color: #f4516c #f4516c #f4516c transparent
.l-btn-loading-warning
    border: 2px solid #ffe57f
    border-color: #ffe57f #ffe57f #ffe57f transparent
.l-btn-disabled
    opacity: 0.8
    background-color: #dee2e6
.icon
    display: flex !important
.margin-mini
    margin-right: 5px
.margin-medium
    margin-right: 9px
.margin-large
    margin-right: 12px
@keyframes btn-spin
    0%
        transform: rotate(0)
    100%
        transform: rotate(360deg)
</style>
